import ApiGet from "../../../../api-module/api-configuration/get-api/getApi";
import { CountryOption } from "../../../../component-module/component-services/input/phone-number";
import { API_ENDPOINTS } from "../../../../context-module/context-configuration/auth-provider/apiGroup/apiProvider";

export interface SalesContactFormData {
  object: string;
  fullName: string;
  companyName: string;
  businessEmail: string;
  country: string;
  phone: string;
  message: string;
  consent: boolean;
  dialCode: string;
}

export const initialSalesContactFormData: SalesContactFormData = {
  object: '',
  fullName: '',
  companyName: '',
  businessEmail: '',
  country: '',
  phone: '',
  message: '',
  consent: false,
  dialCode: '',
};

export const objectOptions = [
  { value: 'proposal', label: 'Request a Proposal' },
  { value: 'productInfo', label: 'Product Information Request' },
  { value: 'callback', label: 'Request a Call Back' },
  { value: 'salesInquiry', label: 'Sales Inquiry' },
];

export const switchContactItems = (navigate: (path: string) => void) => [
  {
    id: '1',
    description: 'Contact our team to explore innovative solutions.',
    buttonText: 'Contact us',
    onButtonClick: () => navigate('/contact/business-contact'),
  },
  {
    id: '2',
    description: 'Join our team and grow your careers',
    buttonText: 'Join us',
    onButtonClick: () => navigate('/career'),
  }
];

export type SaleContactPageData = {
  saleContact: SaleContactContent;
};

export type SaleContactContent = {
  key: string;
  title: string;
  visible: boolean;
  cta: SaleContactCta[];
};

export type SaleContactCta = {
  saleContactSection?: SaleContactSection;
};

export type SaleContactSection = {
  key: string;
  visible: boolean;
  content: Array<{
    headerSection?: SaleContactHeaderSection;
    breadCrumbSection?: SaleContactBreadCrumbSection;
  }>;
};

export type SaleContactHeaderSection = {
  key: string;
  title?: string;
  description?: string;
  visible: boolean;
  lists: SaleContactListItem[];
};

export type SaleContactListItem = {
  id: number;
  label: string;
  title: string;
};

export type SaleContactBreadCrumbSection = {
  key: string;
  visible: boolean;
  breadCrumbTitleNd?: string;
  breadCrumbTitleSt?: string;
};

export interface CountryApiItem {
  iso: string;
  name: string;
  dialCode: string;
  flag: string;
}

export interface CountryApiResponse {
  success: boolean;
  requestId: string;
  data: CountryApiItem[];
}

export const mapCountryOptions = (countries: CountryApiItem[]): CountryOption[] => {
  return countries.map((c) => ({
    code: c.iso,
    name: c.name,
    dialCode: c.dialCode,
    flag: c.flag,
  }));
};


export const getCountry = () =>
  ApiGet<CountryApiResponse>(API_ENDPOINTS.GET_COUNTRY);